import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../supabase';
import { fetchCategoryCount, retrieveUserEmail, fetchBusinessType, fetchCategoryIds } from '../bridge';
import Logo from '../components/Logo';
import { ReactComponent as MyIcon } from '../catalogue.svg';
import { ReactComponent as MyIcon2 } from '../store.svg';
import { ReactComponent as MyIcon3 } from '../portfolio.svg';
import Category from '../components/Category';
import BusinessInfo from '../components/BusinessInfo';
import BusinessDescription from '../components/BusinessDescription';
import ContactInfo from '../components/ContactInfo';
import Switch from '../components/Switch';
import Footer from '../components/Footer';
import StoresLayout from '../components/StoresLayout';
import PortfolioLayout from '../components/PortfolioLayout';
import '../styles/BusinessDisplaying.css';

const BusinessDisplaying = () => {
  const { accountId, businessName } = useParams();
  const [businessType, setBusinessType] = useState('');
  const [uploaders, setUploaders] = useState([]);
  const [userEmail, setUserEmail] = useState('');
  const [info, setInfo] = useState(true);
  const [menu, setMenu] = useState(false);
  const [loading, setLoading] = useState(true);
  const [sectionsCount, setSectionsCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userEmailFB = await retrieveUserEmail({ accountId, businessName });
        if (userEmailFB) {
          setUserEmail(userEmailFB);

          const previousCategoryIds = await fetchCategoryIds(userEmailFB);

          const userBusinessType = await fetchBusinessType(userEmailFB);
          setBusinessType(userBusinessType.business_type);

          const previousCategoryCount = await fetchCategoryCount(userEmailFB);
          const uploadersArr = Array.from({ length: previousCategoryCount + 1 }, (_, i) => ({
            id: i,
            category_id: previousCategoryIds[i]?.category_id ?? null, // Assign category_id or null
          }));
          setUploaders(uploadersArr);
          const count = uploadersArr.filter((u) => u.category_id !== null).length;
          setSectionsCount(count);
        }
      } catch (error) {
        console.error('Error fetching store data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [businessName, accountId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  const handleSelection = (category) => {

    if (category === 'info') {
        setInfo(true);
        setMenu(false);
    }
  
    if (category === 'menu') {
        setMenu(true);
        setInfo(false);
    }
  };

  return (
    <div className='main-container gamified-bg'>
      <Logo />
        <div className="content-wrap fade-in-up">
          <BusinessInfo userEmail={userEmail} businessType={businessType} />
          <Switch handleSelection={handleSelection} info={info} menu={menu} />
          { info && (
          <div className="info-sections fade-in-up">
            <BusinessDescription userEmail={userEmail}/>
            <ContactInfo userEmail={userEmail}/>
          </div>
          )}
          {menu && (
          <div className="section-card fade-in-up">
            {(businessType === 'Restaurant' || businessType === 'Other') && (
            <>
              <div className="icon-header">
                <MyIcon width={60} height={60} />
                <h2 className="sections-headers">Menu</h2>
                {sectionsCount > 0 && (
                  <span className="chip">{sectionsCount} sections</span>
                )}
              </div>
            {uploaders.map((uploader) => (
              <div key={uploader.id} style={{ paddingInlineStart: '10px'}}>
                <Category supabase={supabase} userEmail={userEmail} uploaderId={uploader.category_id} />
              </div>
            ))}
            </>
            )}
            {businessType === 'Store' && (
              <>
                <div className="icon-header">
                  <MyIcon2 width={70} height={70} />
                  <h2 className="sections-headers">Store</h2>
                  <span className="chip alt">Explore</span>
                </div>
                <StoresLayout userEmail={userEmail}/>
              </>
            )}
            {businessType === 'Service Provider' && (
            <>
              <div className="icon-header">
                <MyIcon3 width={60} height={60} />
                <h2 className="sections-headers">Portfolio</h2>
                {sectionsCount > 0 && (
                  <span className="chip">{sectionsCount} sets</span>
                )}
              </div>
            {uploaders.map((uploader) => (
              <div key={uploader.id} style={{ paddingInlineStart: '10px' }}>
              <PortfolioLayout
                supabase={supabase}
                userEmail={userEmail}
                uploaderId={uploader.category_id}
              />
            </div>
            ))}
            </>
            )}
          </div>
          )}
        </div>
      <Footer />
    </div>
  );
};

export default BusinessDisplaying;
